import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  // Switch,
} from "@mui/material";
import React, { useState } from "react";
import { Switch } from "@nextui-org/react";

function CustomUserFilter(props) {
  // users are sorted in ascending order of their last name
  const [isAllSelected, setIsAllSelected] = useState(true);

  const sortedUsers = props.users.sort((a, b) =>
    a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
  );

  const handleSelectAll = () => {
    setIsAllSelected(!isAllSelected);
    props.toggleAllUserFilter(!isAllSelected);
  }

  return (
    // <Accordion disableGutters expanded = {props.expandedSetUsers} onChange = {props.handleAccordionChange}>
    //   <AccordionSummary
    //       expandIcon = {<ExpandMore/>}
    //       sx = {styles.accordionSummary}
    //       >
    //       <div className='custom-date-accordion-summary-text'>Team Members</div>
    //   </AccordionSummary>
    //   <AccordionDetails sx = {styles.accordionDetails}>
    <>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between px-3">
          <h4 className="dark:text-white">Select All Members</h4>
          <Switch isSelected={isAllSelected} onChange={() => handleSelectAll()} />
        </div>
        {sortedUsers.map((user) => {
          const isSelected =
            props.userFilter.find((filter) => filter.email === user.email) !== undefined
              ? true
              : false;
          return (
            <>
            {
              (user.show)?
              (
              <div className="flex justify-between px-3" key={user.email}>
                <h4 className="dark:text-white">{user.displayName}</h4>
                <Switch isSelected={isSelected} onChange={() => props.toggleUserFilter(user)} />
              </div>
              ):(
              <>
              </>
              )}
            </>
          );
        })}
      </div>
      {/* <List dense disablePadding sx={styles.list}>
      {sortedUsers.map((user) => {
        const isSelected =
          props.userFilter.find((filter) => filter.email === user.email) !== undefined
            ? true
            : false;

        return (
          <ListItem
            disablePadding
            key={user.email}
            onClick={() => props.toggleUserFilter(user)}
            secondaryAction={
              <Switch
                edge="end"
                sx={styles.switch}
                // check if that user is in the user filter
                checked={isSelected}
              />
            }
          >
            <ListItemButton selected={isSelected}>
              <ListItemText primary={user.displayName} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List> */}
    </>
    //   </AccordionDetails>
    // </Accordion>
  );
}

const styles = {
  accordionSummary: {
    backgroundColor: "var(--secondary-color)",
  },
  accordionDetails: {
    background: "white",
    padding: "0",
  },
  list: {
    width: "100%",
  },
  switch: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "var(--primary-color)",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "var(--secondary-color)",
    },
  },
};

export default CustomUserFilter;
